import Model, { attr, belongsTo } from '@ember-data/model';
import { memberAction } from 'ember-api-actions';
import type CommunityCourseStageSolutionModel from './community-course-stage-solution';

export default class CommunitySolutionExportModel extends Model {
  @belongsTo('community-course-stage-solution', { async: false, inverse: 'exports' })
  declare communitySolution: CommunityCourseStageSolutionModel;

  @attr('date') declare expiresAt: Date;
  @attr('string') declare githubRepositoryUrl: string | null;
  @attr('string') declare status: 'provisioning' | 'provisioned';

  get isExpired(): boolean {
    return new Date() >= this.expiresAt;
  }

  get isProvisioned(): boolean {
    return this.status === 'provisioned';
  }

  githubUrlForFile(filename: string): string {
    return `${this.githubRepositoryUrl}/blob/main/${filename}`;
  }

  declare markAsAccessed: (this: Model, payload: unknown) => Promise<void>;
}

CommunitySolutionExportModel.prototype.markAsAccessed = memberAction({
  path: 'mark-as-accessed',
  type: 'post',
});
